module.exports = new Promise(resolve => {
        const remoteUrlWithVersion = window.BeekeeperCdn + '/chats/__bundles/webComponentsRemoteEntry.js';

        const script = document.createElement('script');
        script.src = remoteUrlWithVersion;
        script.onload = () => {
            const proxy = {
                get: (request) => window.BeekeeperChatsWebComponents.get(request),
                init: (...arg) => {
                    try {
                        return window.BeekeeperChatsWebComponents.init(...arg);
                    } catch(e) {
                        console.error('remote container already for BeekeeperChatsWebComponents already initialized');
                    }
                }
            }

            resolve(proxy);
        }

        // Failure Handler
        script.onerror = () => {
            console.error('Failed to load remote: BeekeeperChatsWebComponents at ' + remoteUrlWithVersion);
            
            // Resolve with a "Null Object" pattern so the host doesn't crash
            const fallbackProxy = {
                get: (request) => {
                    // Return a function that returns a component or module
                    // This allows the host's to still "resolve"
                    return Promise.resolve(() => ({
                        default: () => null
                    }));
                },
                init: () => {}
            };
            resolve(fallbackProxy);
        };

        document.head.appendChild(script);
    })
    ;